import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import {
  AutomotiveAftermarketProfileItemState,
  AutomotiveAftermarketProfileItemStateModel,
} from './automotive-aftermarket-profile-item.state';
import {
  AutomotiveAftermarketProfileItemClone,
  AutomotiveAftermarketProfileItemCreate,
  AutomotiveAftermarketProfileItemDelete,
  AutomotiveAftermarketProfileItemInitialState,
  AutomotiveAftermarketProfileItemLoad,
  AutomotiveAftermarketProfileItemSave,
  AutomotiveAftermarketProfileItemUpdate,
} from './automotive-aftermarket-profile-item.actions';
import { AutomotiveAftermarketProfileDetails, AutomotiveAftermarketProfileModel } from '../models';
import { MatDialogRef } from '@angular/material/dialog';

@Injectable({ providedIn: 'root' })
export class AutomotiveAftermarketProfileItemFacade implements LoadDataFacade, SetInitialStateFacade {
  profileId$: Observable<number> = this.store.select(AutomotiveAftermarketProfileItemState.getProfileId);
  profile$: Observable<AutomotiveAftermarketProfileItemStateModel> = this.store.select(
    AutomotiveAftermarketProfileItemState.getState,
  );
  loaded$: Observable<boolean> = this.store.select(AutomotiveAftermarketProfileItemState.getLoaded);

  constructor(private store: Store) {}

  loadAll(transportPlannerProfileId: number): void {
    this.store.dispatch(new AutomotiveAftermarketProfileItemLoad(transportPlannerProfileId));
  }

  createProfile(profile: Partial<AutomotiveAftermarketProfileModel>, dialog: MatDialogRef<unknown>): void {
    this.store.dispatch(new AutomotiveAftermarketProfileItemCreate({ dialog, profile }));
  }

  saveProfile(profile: Partial<AutomotiveAftermarketProfileDetails>): void {
    this.store.dispatch(new AutomotiveAftermarketProfileItemSave(profile));
  }

  updateProfile(data: Partial<AutomotiveAftermarketProfileModel>): void {
    this.store.dispatch(new AutomotiveAftermarketProfileItemUpdate(data));
  }

  cloneProfile(data: AutomotiveAftermarketProfileModel): void {
    this.store.dispatch(new AutomotiveAftermarketProfileItemClone(data));
  }

  //TODO: check where it's used
  deleteProfile(profileId: number, dialog: MatDialogRef<unknown>): void {
    this.store.dispatch(new AutomotiveAftermarketProfileItemDelete({ dialog, profileId }));
  }

  setInitialState(): void {
    this.store.dispatch(new AutomotiveAftermarketProfileItemInitialState());
  }
}
